const { webFlagsData } = require('./web');
const { mobileFlagsData } = require('./mobile');
const { apiFlagsData } = require('./api');

module.exports = {
  apiFlagsData,
  mobileFlagsData,
  webFlagsData,
};
